import {useMutation} from '@tanstack/react-query';

import {bindExternalParticipant} from '../api';

export const useBindExternalParticipant = () => {
  return useMutation({
    mutationFn: bindExternalParticipant,
  });
};
